import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomSkeleton, {ATOM_SKELETON_VARIANTS} from '@s-ui/react-atom-skeleton'
import Context from '@s-ui/react-context'
import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'

export const UnsubscribeEmailsSkeleton = ({pageState}) => {
  const {domain} = useContext(Context)
  const config = domain.get('config')
  const isMobile = config.get('isMobile')

  const skeletonConfig = {
    desktop: [
      {id: 'siteLogo', height: '22px'},
      {id: 'image', height: '230px'},
      {id: 'pretitle', height: '18px', width: '206px'},
      {id: 'title', height: '82px'},
      {id: 'checkboxSection', height: '110px'},
      {id: 'buttonsContainer', height: '50px'}
    ],
    mobile: [
      {id: 'siteLogo', height: '16px'},
      {id: 'image', height: '180px'},
      {id: 'pretitle', height: '18px', width: '206px'},
      {id: 'title', height: '98px'},
      {id: 'checkboxSection', height: '154px'},
      {id: 'buttonsContainer', height: '104px'}
    ]
  }

  const initialMediaQueryMatch = {
    defaultMatches: !isMobile
  }
  const isTabletOrWider = useMediaQuery(useMediaQueryBreakpoints.md, initialMediaQueryMatch)
  const skeleton = isTabletOrWider ? skeletonConfig.desktop : skeletonConfig.mobile
  return (
    <>
      {skeleton.map(({id, height, width = ''}, i) => (
        <div className={`mt-UserUnsubscribeEmails-${id}`}>
          <AtomSkeleton height={height} key={`${i}-${id}`} variant={ATOM_SKELETON_VARIANTS.round} width={width} />
        </div>
      ))}
    </>
  )
}

UnsubscribeEmailsSkeleton.displayName = 'UnsubscribeEmailsSkeleton'
UnsubscribeEmailsSkeleton.propTypes = {
  pageState: PropTypes.string
}
